import { lazyWithRetry } from "utils";

export const CreateRationaleTemplate = lazyWithRetry(() => import("./containers/CreateRationaleTemplate"));
export const DenialRationalManagement = lazyWithRetry(() => import("./containers/index"));
